module.exports = __webpack_public_path__ + "img/Call (1).4fcc6ab3.svg";